import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateShippingRateRequest } from '../common/model/dto/shipping-rate/create-shipping-rate-request';
import { UpdateShippingRateRequest } from '../common/model/dto/shipping-rate/update-shipping-rate-request';
import {
  createShippingRate,
  deleteShippingRate,
  updateShippingRate,
} from '../services/admin/admin-shipping-rate.service';

export function useAdminShippingRateMutations() {
  const qc = useQueryClient();

  const invalidateList = () =>
    qc.invalidateQueries({ queryKey: ['admin-shipping-rates'] });

  const createRate = useMutation({
    mutationFn: (request: CreateShippingRateRequest) =>
      createShippingRate(request),
    onSuccess: invalidateList,
  });

  const updateRate = useMutation({
    mutationFn: ({
      id,
      request,
    }: {
      id: string;
      request: UpdateShippingRateRequest;
    }) => updateShippingRate(id, request),
    onSuccess: (_, { id }) => {
      qc.invalidateQueries({ queryKey: ['admin-shipping-rate', id] });
      invalidateList();
    },
  });

  const deleteRate = useMutation({
    mutationFn: (id: string) => deleteShippingRate(id),
    onSuccess: (_, id) => {
      qc.removeQueries({ queryKey: ['admin-shipping-rate', id] });
      invalidateList();
    },
  });

  return { createRate, updateRate, deleteRate };
}
